module.exports = __webpack_public_path__ + "static/media/our_world_in_data.4a50bda7.jpg";